import { Card } from 'bricks-ui/packages/bricks-ui';

export default Card;
